import Typography from "antd/lib/typography";
import { useEffect } from "react";
import { colors } from "../styles/themes";
import useStringStateWithDebounce from "../utils/useStringStateWithDebounce";

const keyMap: Record<string, string | undefined> = {
  q: "/",
  w: "'",
  e: "ק",
  r: "ר",
  t: "א",
  y: "ט",
  u: "ו",
  i: "ן",
  o: "ם",
  p: "פ",
  a: "ש",
  s: "ד",
  d: "ג",
  f: "כ",
  g: "ע",
  h: "י",
  j: "ח",
  k: "ל",
  l: "ך",
  ";": "ף",
  z: "ז",
  x: "ס",
  c: "ב",
  v: "ה",
  b: "נ",
  n: "מ",
  m: "צ",
  ",": "ת",
  ".": "ץ",
};
const KEY_CONTROL_TIMEOUT = 1500;

const specialKey = (event: KeyboardEvent) =>
  event.altKey || event.shiftKey || event.metaKey || event.ctrlKey;

const KeyboardControl = ({
  submit,
  clearBoard,
  shuffle,
  gridRef,
}: {
  gridRef: React.RefObject<HTMLDivElement>;
  submit: () => void;
  clearBoard: () => void;
  shuffle: () => void;
}) => {
  const { value, append, backspace, flush } = useStringStateWithDebounce(
    "",
    KEY_CONTROL_TIMEOUT,
  );
  const isSelected = (el: HTMLButtonElement) =>
    value.length > 0 &&
    el.textContent?.toLowerCase().startsWith(value.toLowerCase());
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      let key =
        e.code === "Space" || /[א-ת]/.test(e.key)
          ? e.key
          : keyMap[e.key.toLowerCase()];
      if (key === " " && value.length === 0) {
        return;
      }
      if (key && !specialKey(e)) {
        append(key);
      }
      if (e.key === "Backspace" && (e.ctrlKey || e.metaKey)) {
        clearBoard();
      } else if (e.key === "Backspace") {
        backspace();
      }
      if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
        submit();
      } else if (e.key === "Enter" && e.shiftKey) {
        shuffle();
      } else if (e.key === "Enter") {
        const selectedElements = Array.from(
          gridRef.current?.querySelectorAll("button") || [],
        ).filter((el) => isSelected(el));
        if (selectedElements.length === 1) {
          selectedElements[0].click();
        }
        flush();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });
  Array.from(gridRef.current?.querySelectorAll("button") || []).forEach(
    (el) => {
      const selected = isSelected(el);
      el.style.border = selected ? `4px solid ${colors.wordText}` : "";
    },
  );

  const selectedNames: string[] = Array.from(
    gridRef.current?.querySelectorAll("button") || [],
  )
    .filter((el) => isSelected(el))
    .map((el) => el.textContent!)
    .filter((x) => x !== null);

  return (
    <Typography.Text
      aria-live={"assertive"}
      aria-label={`חיפוש: ${value}${selectedNames.length === 0 ? "" : `, מילים: ${selectedNames.join(",")}`}`}
      style={{
        position: "absolute",
        top: "140px",
        backgroundColor: colors.bg,
        fontWeight: 600,
        padding: 2,
        boxShadow: "2px 2px 2px rgba(0,0,0,0.2)",
        display: value.length > 0 ? "block" : "none",
        border: `2px solid ${colors.wordText}`,
        borderRadius: 5,
        fontFamily: "Open Sans",
      }}
    >
      <div aria-hidden={true}>{value}</div>
    </Typography.Text>
  );
};

export default KeyboardControl;
